import { useMemo } from 'react';
import { Tag } from 'antd';
import {
  FaGoogle,
  FaFacebookF,
  FaUsers,
  FaInstagram,
  FaWhatsapp,
  FaGift,
  FaQuestionCircle,
  FaWalking,
} from 'react-icons/fa';

export const useSourceRender = () => {
  return useMemo(
    () => (source: string) => {
      const sourceConfigs: Record<
        string,
        {
          text: string;
          icon: React.ReactNode;
          bgColor: string;
          textColor: string;
          borderColor: string;
        }
      > = {
        GOOGLE: {
          text: 'Google',
          icon: <FaGoogle />,
          bgColor: '#fff2e8',
          textColor: '#d4380d',
          borderColor: '#ffbb96',
        },
        FACEBOOK: {
          text: 'Facebook',
          icon: <FaFacebookF />,
          bgColor: '#e6f0ff',
          textColor: '#1877f2',
          borderColor: '#91caff',
        },
        REFERRAL: {
          text: 'Referral',
          icon: <FaUsers />,
          bgColor: '#f6ffed',
          textColor: '#52c41a',
          borderColor: '#b7eb8f',
        },
        INSTAGRAM: {
          text: 'Instagram',
          icon: <FaInstagram />,
          bgColor: '#fff0f6',
          textColor: '#eb2f96',
          borderColor: '#ffadd2',
        },
        WHATSAPP: {
          text: 'WhatsApp',
          icon: <FaWhatsapp />,
          bgColor: '#f6ffed',
          textColor: '#389e0d',
          borderColor: '#95de64',
        },
        WALK_IN: {
          text: 'Walk-In',
          icon: <FaWalking />,
          bgColor: '#fff7e6',
          textColor: '#fa8c16',
          borderColor: '#ffd591',
        },
        COUPON: {
          text: 'Coupon',
          icon: <FaGift />,
          bgColor: '#f9f0ff',
          textColor: '#722ed1',
          borderColor: '#d3adf7',
        },
        OTHER: {
          text: 'Other',
          icon: <FaQuestionCircle />,
          bgColor: '#fafafa',
          textColor: '#8c8c8c',
          borderColor: '#d9d9d9',
        },
      };

      const config = sourceConfigs[source] || {
        text: source || 'Unknown',
        icon: <FaQuestionCircle />,
        bgColor: '#f5f5f5',
        textColor: '#8c8c8c',
        borderColor: '#d9d9d9',
      };

      return (
        <Tag
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontWeight: 500,
            padding: '4px 8px',
            borderRadius: '6px',
            lineHeight: '1.2',
            backgroundColor: config.bgColor,
            color: config.textColor,
            border: `1px solid ${config.borderColor}`,
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {config.icon}
          </span>
          <span>{config.text}</span>
        </Tag>
      );
    },
    []
  );
};
